<template>
  <div class="board_pagemove_wrap">
    <div class="board_pagemove">
      <a
        href="#"
        class="first"
        :class="{ disable: currentPage === 1 }"
        @click.prevent="paginate(1)"
      >
        <span>{{ $t('common.ui.first') }}</span>
      </a>
      <a
        href="#"
        class="prev"
        :class="{ disable: currentPage === 1 }"
        @click.prevent="paginate(pagePrev)"
      >
        <span>{{ $t('common.ui.previous') }}</span>
      </a>
      <ul>
        <li
          v-for="i in pages.slice(pageStart, pageEnd)"
          :key="i"
          :class="{ on: i === currentPage }"
          @click.prevent="paginate(i)"
        >
          <a href="#"> {{ i }}</a>
        </li>
      </ul>
      <a
        href="#"
        class="next"
        :class="{ disable: currentPage === pages[pages.length - 1] }"
        @click.prevent="paginate(pageNext)"
      >
        <span>{{ $t('common.ui.next') }}</span>
      </a>
      <a
        href="#"
        class="end"
        :class="{ disable: currentPage === pages[pages.length - 1] }"
        @click.prevent="paginate(pages.length)"
      >
        <span>{{ $t('common.pagination.2245') }}</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    },
    itemPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pagesPerPage: 10,
      width: 0
    }
  },
  computed: {
    pages() {
      const pages = [
        ...Array(Math.ceil(this.totalCount / this.itemPerPage) || 1).keys()
      ].map((i) => i + 1)
      return pages
    },
    pageStart() {
      let pagesCount = Math.ceil(this.currentPage / this.pagesPerPage)
      if (Math.ceil(this.currentPage / 10) == 0) return 0
      const start = pagesCount * this.pagesPerPage - this.pagesPerPage + 1
      return start - 1
    },
    pageEnd() {
      let pagesLastCount =
        Math.ceil(this.currentPage / this.pagesPerPage) * this.pagesPerPage
      const end =
        pagesLastCount > this.totalCount / this.itemPerPage
          ? this.pages.length + 1
          : pagesLastCount
      return end
    },
    pagePrev() {
      let prev =
        (Math.ceil(this.currentPage / this.pagesPerPage) - 1) *
        this.pagesPerPage
      return prev
    },
    pageNext() {
      let next =
        Math.ceil(this.currentPage / this.pagesPerPage) * this.pagesPerPage + 1
      return next
    }
  },
  watch: {
    width: function (val) {
      if (val > 1024) {
        this.pagesPerPage = 10
      } else {
        this.pagesPerPage = 5
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    paginate(page) {
      if (page < 1) {
        return
      }

      if (page > this.pages[this.pages.length - 1]) {
        // return
        page = this.pages[this.pages.length - 1]
      }

      if (this.currentPage === page) {
        return
      }
      this.$emit('paginate', page)
    },
    handleResize() {
      this.width = window.innerWidth
    }
  }
}
</script>
